<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'RolesReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/roles'
    }
  }
}
</script>
